<div class="my-3 my-md-5">
    <div class="container" *ngIf="myrole=='1'">
        <div class="row">
            <h3 class="bold">BD Wise Report</h3>
            <mat-accordion class="example-headers-align w-100" multi>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="row mb-2 mt-2">
                        <div class="col-sm-3 mt-2">
                            <mat-select placeholder="Bds" [(ngModel)]="bd" (click)="setSearchValue('bds')" multiple
                                #itemSelect="ngModel">
                                <input class="mySearchInput" #bd_search focused="'true'" type="text"
                                    (keyup)="searchOnSelect($event.target.value, 'bds')"
                                    (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                    id="bd_search">
                                <mat-option value="{{bd.id}}" *ngFor="let bd of bds">{{bd.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-3 mt-2">
                            <mat-form-field appearance="fill">
                                <mat-label>Enter date range</mat-label>
                                <mat-date-range-input [rangePicker]="picker">
                                    <input matStartDate #dateRangeStart placeholder="Start date">
                                    <input matEndDate #dateRangeEnd placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                                </mat-date-range-input>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker></mat-date-range-picker>
                            </mat-form-field>
                            <mat-icon (click)="clearDate()">clear</mat-icon>

                        </div>
                        <div class="col-sm-3 mt-2">
                            <button type="button" class="btn btn-primary ml-2 mb-4" (click)="getBdReportList()"> <i class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                            <button type="button" class="btn btn-primary ml-2 mb-4" (click)="resetFilters()"> <i class="fa fa-sync"></i> Reset Filters</button>
                        </div>

                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
        <div class="row row-cards mt-2">
            <div class="card">
                <div class="table-responsive" style="height: 700px;">
                    <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
                        <thead>
                            <tr class="text-center">
                                <th>BD NAME</th>
                                <th>Lead Count</th>
                                <th>Ipd Count</th>
                                <th>PX Referral Ipd's</th>
                                <th>Gp channel Ipd's</th>
                                <th>Lab Referral Ipd's</th>
                                <th>Others Sources Ipd's</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="text-center" *ngFor="let reportData of bdReportList">
                                <td>{{reportData.name}}</td>
                                <td>{{reportData.assigned_lead ? reportData.assigned_lead : 0}}</td>
                                <td>{{reportData.ipd_count ? reportData.ipd_count : 0}}</td>
                                <td>{{reportData.px_referral_ipd_count ? reportData.px_referral_ipd_count : 0}}</td>
                                <td>{{reportData.gp_referral_ipd_count ? reportData.gp_referral_ipd_count : 0}}</td>
                                <td>{{reportData.lab_referral ? reportData.lab_referral : 0}}</td>
                                <td>{{ reportData.ipd_count - (reportData.px_referral_ipd_count + reportData.gp_referral_ipd_count + reportData.lab_referral) }}</td>
                            </tr>
                            <tr *ngIf="bd_report_loading">
                                <td colspan="7" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>